let debugMode = false;
export function enableDebugMode() {
    debugMode = true;
}
export function isDebugMode() {
    return debugMode;
}
//# sourceMappingURL=debug.js.map